export default "__VITE_ASSET__BUwDdMii__"